import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, createHashRouter, RouterProvider } from 'react-router'
import { routes } from './routes'
import './styles.css'
import './workspace.css'
import './workspace-blue.css'
import './workspace-v3.css'
import './workspace-v4.css'
// The Bentley-style flat revision (22 October 2026): imported last so its
// few overrides win over the page sheets and the earlier workspace sheets.
import './workspace-v5.css'
import './review-tools.css'

async function mount() {
  // Demo data is a build-time choice, never a response to a failed live API.
  // The dynamic branch is removed from ordinary production builds.
  const demo = import.meta.env.VITE_DEMO_MODE === 'true'
  if (demo) {
    const { installDemoApi } = await import('./demo')
    installDemoApi()
  }
  // The isolated static demonstration has no server-side route rewrites.
  // Production keeps its existing history URLs and same-origin deployment.
  const router = (demo ? createHashRouter : createBrowserRouter)(routes)

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
    <RouterProvider router={router} />
    </StrictMode>,
  )
}

void mount()
